import * as types from "../constants";

const initialState = {
  isLoading: false,
  error: null,
  items: [],
  unreadNumber: 0,
};

export default function notificationsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_NOTIFICATIONS_INIT:
      return { ...state, error: null, isLoading: false };

    case types.GET_NOTIFICATIONS_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    case types.SET_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        unreadNumber: action.payload,
      };

    default:
      return state;
  }
}
